module.exports = __webpack_public_path__ + "img/cloud_download_black_24dp.a70d032b.svg";